import type { ReactNode } from 'react';

interface NumberedCardProps {
  /** 1-based position, shown in the badge. */
  position: number;
  /** Optional heading beneath the badge. */
  label?: string;
  children: ReactNode;
}

/**
 * One bordered card led by its number. The shape the redesign uses wherever a section
 * lists findings that are ordered but not ranked: sub-cultures, adjacent audiences, the
 * marketing-performance insights.
 *
 * The number sits above the label rather than beside it, so a long label does not push the
 * badge off its own line.
 */
export const NumberedCard = ({ position, label, children }: NumberedCardProps) => (
  <div className="flex h-full flex-col gap-3 rounded-lg border border-border-light p-xl">
    <div className="flex flex-col items-start gap-3">
      <span className="grid size-7 shrink-0 place-items-center rounded-md bg-accent text-label-md font-medium text-primary">
        {position}
      </span>
      {label && <span className="text-body-xl font-medium text-foreground">{label}</span>}
    </div>
    {children}
  </div>
);
